import { render, staticRenderFns } from "./CommunityEdit.vue?vue&type=template&id=01a2e614&scoped=true&"
import script from "./CommunityEdit.vue?vue&type=script&lang=ts&"
export * from "./CommunityEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityEdit.vue?vue&type=style&index=0&id=01a2e614&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2e614",
  null
  
)

export default component.exports